<h3 class="titulo" *ngIf="modoCadastro">Cadastro de ECG por Terceiros</h3>
<h3 class="titulo" *ngIf="modoEdicaoR || modoVisualizacao">Detalhes do ECG por Terceiros (edição)</h3>
<section class="container">
  <div class="bn-form-group row">
    <div class="col">
    </div>
    <div class="col-auto" style="direction: rtl;">
      <button *ngIf="modoCadastro" type="button" class="btn btn-primary" (click)="salvar()"> Salvar </button>
      <button *ngIf="modoCadastro" type="button" class="btn btn-danger" routerLink=".."> Cancelar </button>

      <button *ngIf="modoVisualizacao" type="button" class="btn btn-primary"  routerLink="../.."> Voltar </button>
      <button *ngIf="modoVisualizacao" type="button" class="btn btn-success no-margin"  (click)="editarLimite()"> Editar Limite </button>
      <button *ngIf="modoEdicaoR" type="button" class="btn btn-primary" (click)="salvarEdicao()"> Salvar </button>
      <button *ngIf="modoEdicaoR" type="button" class="btn btn-primary"  (click)="cancelar()"> Voltar </button>
    </div>
  </div>
  <form [formGroup]="cadastroTerceiroForm">
    <div class="row">
      <div class="bn-form-group col-5">
        <label class="form-label"><b>ECG pago por: </b></label>
        <input
          type="text"
          class="form-control"
          formControlName="pagamentoEcgPor"
          name="pagamentoEcgPor"/>
      </div>
      <div class="bn-form-group col-4">
        <label class="form-label"><b>Limite total ECG pago por Terceiro: </b></label>
        <input
          type="text"
          class="form-control"
          formControlName="valorLimiteTotal"
          name="valorLimiteTotal"
          bnMask="MOEDA"/>
      </div>
      <div class="bn-form-group col-3">
        <label class="form-label"><b>Data de referência: </b></label>
        <bn-datepicker [minDate]="dataAmanha" formControlName="dataReferencia"></bn-datepicker>
      </div>
    </div>
  </form>
</section>

<div class="container mt-3 mx-auto" *ngIf="modoEdicaoR || modoVisualizacao">
  <div class="alert alert-info" *ngIf="!limitesCedidosEcg || !limitesCedidosEcg.length">
    Não foram encontrados ECG por terceiros concedidos.
  </div>

  <div *ngIf="limitesCedidosEcg && limitesCedidosEcg.length">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr class="text-nowrap">
          <th scope="col">Em utilização por</th>
          <th scope="col">Valor limite total disponibilizado</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let limite of limitesCedidosEcg">
          <td>{{ limite.nomeTipoPagamentoEcgTerceiro }}</td>
          <td>R$ {{ limite.valorLimiteTotal | bnMask: 'MOEDA' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
